
export default {
    setPapel(state, data) {
        state.papel = data
    },
    setPapeis(state, data) {
        state.papeis = data
    },
}